import { render } from "./_Index.vue?vue&type=template&id=5cc6ad71&scoped=true"
import script from "./_Index.vue?vue&type=script&lang=ts"
export * from "./_Index.vue?vue&type=script&lang=ts"

import "./_Index.vue?vue&type=style&index=0&id=5cc6ad71&scoped=true&lang=css"
import "./_Index.vue?vue&type=style&index=1&id=5cc6ad71&lang=css"
script.render = render
script.__scopeId = "data-v-5cc6ad71"

export default script